import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: localStorage.getItem("token") || ""
  },
  mutations: {
    token(state, msg) {
      localStorage.setItem('token', msg);
      state.token = msg;
    }
  },
  actions: {

  }
});



// WEBPACK FOOTER //
// ./src/vuex/store.js